import { useQuery } from "react-query";
import { PagedRequestType } from "../types/PagedResults";
import { getCourses } from "../services/school/course/getCourses";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { CourseType } from "../types/Course";

  export const useGetCoursesQuery = (data: PagedRequestType, options: any = null) => {
    const managerData = useSelector((state: RootState) => state.manager);
    return useQuery(
      ["courses-pagination", JSON.stringify(data)],
      () => managerData 
      && managerData?.idUser
      && managerData.isManager
      && managerData.courses && managerData.courses?.length > 0 ? getCourses(data).then((d) => {
        let filteredCourses:CourseType[] = [];
        if(data?.IdDepartament){
          filteredCourses= d.items.filter((course: any) =>
            managerData.courses?.some((d: any) => d === course.id)
          );
        }
        
        
        return { ...d, items: filteredCourses }
      }) : getCourses(data),
      options ? { ...options } : {}
    );
  };